const money = (n) => `${Math.round(Number(n || 0)).toLocaleString('ru')} ₽`;

// Две суммы над списком заявок: сколько уже оплачено и сколько всего по заявкам (потенциальные
// расходы) — по строкам, видимым сейчас с учётом всех фильтров. Отклонённые не считаются:
// оплачивать их уже не будут.
export default function RequestsSummary({ rows }) {
  const active = rows.filter(r => r.status !== 'rejected');
  const total = active.reduce((s, r) => s + Number(r.amount || 0), 0);
  const paidRows = active.filter(r => r.status === 'paid');
  const paid = paidRows.reduce((s, r) => s + Number(r.amount || 0), 0);
  return (
    <div className="stats-row" style={{ marginBottom: 12 }}>
      <div className="stat-card">
        <div className="stat-value">{money(paid)}</div>
        <div className="stat-label">Оплачено ({paidRows.length} шт.)</div>
      </div>
      <div className="stat-card">
        <div className="stat-value">{money(total)}</div>
        <div className="stat-label">Все заявки — потенциальные расходы ({active.length} шт.)</div>
      </div>
      <div className="stat-card">
        <div className="stat-value">{money(total - paid)}</div>
        <div className="stat-label">Ещё не оплачено</div>
      </div>
    </div>
  );
}
